import { z } from "zod";
import { MetaSchema } from "./shared";
import {
  InterestCalculationMethodEnum,
  TransferPaymentFineEnum,
} from "../enums";

export const LoanInfoDataSchema = z.object({
  id: z.string().uuid(),
  interestRate: z.string(),
  interestCalculationMethod:
    InterestCalculationMethodEnum.interestCalculationMethodSchema,
  repaymentPeriod: z.number(),
  transferPaymentFineType:
    TransferPaymentFineEnum.transferPaymentFineTypeSchema,
  amountLimit: z.number(),
  percentageAmountLateFine: z.string(),
  fixedAmountLateFine: z.string().nullable(),
  percentageMarginCall: z.number(),
  percentageLiquidThreshold: z.number(),
  collateral: z.any().nullable(),
  minimumLtv: z.number(),
  maximumLtv: z.number(),
  currency: z.string(),
  network: z.string(),
  status: z.string().nullable(),
  minimumRank: z.string(),
  createdAt: z.string().datetime(),
  updatedAt: z.string().datetime(),
});

const LoanInfoResponse = z.object({
  data: LoanInfoDataSchema,
  meta: MetaSchema.default,
});

export type LoanInfoResponseType = z.infer<typeof LoanInfoResponse>;

export default LoanInfoResponse;
